module.exports = __webpack_public_path__ + "img/mine.79c5e411.png";